module.exports = __webpack_public_path__ + "img/38_35.42292471.png";